import * as AWS from 'aws-sdk/global';
import { Dataset, ParsedHeader, ParsedMessage, IBACReading, METReading, GPSReading, AlgorithmResult, PlottableSensorReading, PlottableSensorTypes, Device, CBSigmaOutput } from './BD21Device';
//import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js';
import * as messages from '@radnuc/messages';
import * as thrift from 'thrift';
//import Credentials from './creds.json'
//import { promises } from 'dns';
import {SensorDisplaySelection} from './components/BioCountPlotDisplay'
import { uuidToString } from '@radnuc/react-ui-components/dist/UUID';
import { invToEncounter } from '@radnuc/react-ui-components';
import { FakeImageData } from './utils/FakeData';
//import { produce } from 'immer';
import colormap from "colormap";
import npyjs from "npyjs";
import { Parsed } from "npyjs";
import { DoseMapUtility } from './utils/DoseMapUtility';
import jszip from 'jszip';

export type DataPacket = [ParsedHeader, ParsedMessage|null];
type Investigation = messages.Encounter.Encounter | messages.Rad.Investigation; // BioInvestigation;

export type MinMaxPair = {min:number|null,max:number|null};
export type LocationMessage = {lat:number|null,lon:number|null,level:number|null};
export type GroupedLocationMessage = {[device_name:string]:LocationMessage};
export type TiledDoseMapImage = {uuid: string| null;
                                 doseMap: string|null,
                                 maxDoseMap: string|null,
                                 uncertMap:string|null,
                                 doseRaw?:Parsed,
                                 doseStdRaw?:Parsed,
                                 doseMaxRaw?:Parsed,
                                 doseMaxStdRaw?: Parsed,
                                 maskMap?: Parsed,
                                 maskMax?: Parsed,
                                 npzBlob?: Blob;
                                 swCorner: {lat:number|null,lon:number|null},
                                 neCorner: {lat:number|null,lon:number|null},
                                 time: number|null,
                                 dataScaleVal:{[doseDataType:number]:MinMaxPair}}

export type DoseMapMessage = {regions: TiledDoseMapImage[]|null;
                              time: number|null,
                              lastUpdatedTime: number|null,
                              manifest?: string;
                              displayScaleVal:{[doseDataType:number]:MinMaxPair},
                              globalScaleVal:{[doseDataType:number]:MinMaxPair},
                              dataScaleVal:{[doseDataType:number]:MinMaxPair}}

export enum DoseDatatype {DOSE_RATE=1, MAX_DOSE_RATE=2, UNCERTAINTY=3};
type DataSetting = {
            [DoseDatatype.DOSE_RATE]?: {max:number, min:number},
            [DoseDatatype.MAX_DOSE_RATE]?: {max:number, min:number},
            [DoseDatatype.UNCERTAINTY]?: {max:number, min:number},
};

type BinaryImage = String;
export type StreamStatus = {data:boolean,health:boolean,encounter:boolean,location:boolean,doseMap:boolean}

interface DataStreamCallbacks {
    onConnect?: (streamType:StreamType) => void,
    onMessage?: (packets: DataPacket[]) => void,
    onDisconnect?: (streamType:StreamType) => void,
    onHealthMessage?:(message:messages.Core.GroupedHealthMessage) => void,
    onLocationMessage?:(message:GroupedLocationMessage) => void,
    onDoseMapMessage?:(message:DoseMapMessage, key?: string) => void, //MESSAGE TBD
    onQueryInterrupt?: (key:string) => void,
    onBulkMessage?: (packets: DataPacket[]) => void,
    onDoseMapLoadProgress?: (key: string, flag: boolean, percent?: number) => void,
}

type AuthenticationError = Error;
export enum StreamType {DATA, HEALTH, ENCOUNTER, LOCATION, DOSE_MAP};
const API_ROOT = window.app && window.app.env.API_URL;

export class BD21DataStream {

    //static readonly endpoint = "https://3nparjfb15.execute-api.us-east-1.amazonaws.com/dev"; //Old
    //static readonly endpoint = "https://f5tkmzhdh3.execute-api.us-east-1.amazonaws.com/dev";
    static readonly endpoint = API_ROOT.Endpoint; //"https://a4z9gr1042.execute-api.us-east-1.amazonaws.com/dev";
    //static readonly endpoint = "https://lbhrbcrzci.execute-api.us-east-1.amazonaws.com/dev"; //new AWS API (BD21)
    streamType: StreamType|null = null;
    token: string | null = null;
    iterator: string | null = null;

    stream_promise: Promise<void> | null = null;

    callbacks: DataStreamCallbacks;
    cancel: boolean = false;
    delay: number = 0;

    doseMapLoopTimer:NodeJS.Timeout | null = null;
    doseMapLoadAborted = false;

    sensorDisplaySelection: SensorDisplaySelection[] = [];
    sensorDataQueryMap: {[key:string]:{device:string,sensor:string, lastDataTimestamp:number, queryActive:boolean}} = {};
    sensorReplayDataQueryActiveMap: {[key:string]:number} = {};
    //sensorReplayDataQueryMap: {[key:string]:{device:string,sensor:string, lastDataTimestamp:number}} = {};
    lastLiveEncounterDataTimestamp:number = 0;
    lastLiveLocationQueryTimestamp:number = 0;

    doseImageMap: { [key: string]: { lastDataTimestamp: number } } = {};
    doseMapRegions: { [key: string]: TiledDoseMapImage } = {};
    doseMapSettings: DataSetting = {};
    doseMapLive: boolean = false;
    doseMapAbortController: {[key: string]:AbortController} = {};
    lastLiveDoseMapManifest: { [key: string]: {manifest:string|undefined}} = {};

    realtime_query_offet = 5;//Sec

    initQueried= false;

    getTier0_2_Results = false;

    constructor(streamType: StreamType, callbacks: DataStreamCallbacks) {
        this.callbacks = callbacks;
        this.streamType = streamType;

        this.getDoseMapInternal = this.getDoseMapInternal.bind(this);
    }

    connect(token: string) {
        if(this.stream_promise !== null){

            console.log("Connection still not finalized, delaying connect")
            //this.disconnect();
            if (this.callbacks.onDisconnect && this.streamType !== null)
                this.callbacks.onDisconnect(this.streamType);
            return
        }

        this.token = token;
        this.cancel = false;

        if(this.streamType === StreamType.DATA) {
            this.stream_promise = new Promise(async (resolve,reject) => {
                await this.data_loop();
                resolve();
            })
        } else if (this.streamType === StreamType.ENCOUNTER) {
            this.stream_promise = new Promise(async (resolve,reject) => {
                await this.encounter_loop();
                resolve();
            })

        } else if (this.streamType === StreamType.HEALTH) {
            this.stream_promise = new Promise(async (resolve,reject) => {
                await this.health_loop();
                resolve();
            })
        } else if (this.streamType === StreamType.LOCATION) {
            this.stream_promise = new Promise(async (resolve,reject) => {
                await this.location_loop();
                resolve();
            })
        } else if (this.streamType === StreamType.DOSE_MAP) {
            this.stream_promise = new Promise(async (resolve,reject) => {
                await this.dose_map_loop();
                resolve();
            })
        }

    }

    setToken(token: string) {
        this.token = token;
    }

    getActiveQueryMap(){
        return this.sensorReplayDataQueryActiveMap
    }

    setDoseMapSetting(type:DoseDatatype,max:number,min:number){
        this.doseMapSettings[type]={max:max,min:min};
        console.log('Setting map setting '+type+' max: '+max+' min: '+min);
    }

    clearDoseMap(key:string){
        //delete this.doseImageMap[key];
        //delete this.doseMapRegions[key];
        this.doseImageMap = {};
        this.doseMapRegions = {};
        this.lastLiveDoseMapManifest[key] = {manifest:undefined};

    }

    disconnect() {
        this.stream_promise?.finally(() => this.stream_promise = null);
        this.cancel = true;
    }

    setTier0_2ResultFlag(flag: boolean){
        this.getTier0_2_Results = flag;
    }

    setDoseMapLive(flag: boolean){
        this.doseMapLive = flag;
        if(this.doseMapLive){
            if(this.stream_promise === null){
                console.log('Starting dose_map_loop')

                this.stream_promise = new Promise(async (resolve,reject) => {
                    await this.dose_map_loop();
                    resolve();
                })
            }
        } else {
            if(this.doseMapLoopTimer!==null){
                clearTimeout(this.doseMapLoopTimer);
                this.stream_promise = null
            }
        }
    }

    private async data_loop() {
        try {
            //if (this.token === null)
            //    await this.connectInternal();

            if (this.callbacks.onConnect)
                this.callbacks.onConnect(StreamType.DATA);

            while (!this.cancel) {

                if(this.sensorDisplaySelection.length > 0){
                    //console.log(this.sensorDataQueryMap)
                    this.sensorDisplaySelection.forEach( selection => {

                        if(selection.device_name !== '' && selection.device_name !== undefined && selection.sensor_name !== '' && selection.sensor_name !== undefined){
                            const device_sensor = selection.device_name+'_'+selection.sensor_name;
                            let preload_flag = false;
                            if(this.sensorDataQueryMap[device_sensor] === undefined){
                                console.log('preloading '+device_sensor)
                                preload_flag = true;
                                //Initialize sensorDataQueryMap
                                this.sensorDataQueryMap[device_sensor] = {device:selection.device_name, sensor:selection.sensor_name, lastDataTimestamp:0, queryActive:false};
                            }
/*
                            else if (this.sensorDataQueryMap[device_sensor].lastDataTimestamp < Date.now()-30000 && !this.sensorDataQueryMap[device_sensor].queryActive){
                                //last data is older than (Date.now()-30sec)
                                console.log('preloading '+device_sensor+' because last data older than 30 sec. '+this.sensorDataQueryMap[device_sensor].lastDataTimestamp)
                                preload_flag = true;
                            }
*/

                            if(!this.sensorDataQueryMap[device_sensor].queryActive){
                                //This makes each sensor load/display asynchronous
                                this.queryData(selection.device_name,selection.sensor_name,selection.deviceDisplayed,preload_flag);
                            }

                        }

                    })
                    //}
                    //Update preloaded map
                    //console.log(this.sensorDisplaySelection)
                    Object.keys(this.sensorDataQueryMap).forEach(this_key => {
                        let delete_this_key = true;
                        this.sensorDisplaySelection.forEach( selection => {
                            if(selection.device_name !== '' && selection.sensor_name !== ''){
                                const device_sensor = selection.device_name+'_'+selection.sensor_name;
                                //if(this.sensorDataQueryMap[device_sensor] !== undefined){
                                if(device_sensor === this_key){
                                    delete_this_key = false;
                                }
                            }
                        })
                        if(delete_this_key){
                            delete this.sensorDataQueryMap[this_key];
                        }
                    });

                }
                if (this.delay == 0)
                    await new Promise(r => setTimeout(r, 5000));
            }
        } catch (err) {
            console.log(err)
            this.cancel = true;
            //this.token = this.iterator = null;
            this.token = null;
            this.disconnect();
            if (this.callbacks.onDisconnect)
                this.callbacks.onDisconnect(StreamType.DATA);
        }
    }


    async queryData(device:string, sensor:string, nodeName:string, preload_flag:boolean ){
        try {
            if(this.sensorDataQueryMap[device+'_'+sensor])
                this.sensorDataQueryMap[device+'_'+sensor].queryActive = true;

                //CBSIGMA sensor name needs to be 'CBSigmaOutput'
                let this_sensor = sensor;
                if(sensor === 'PSI-CBSIGMA'){
                    this_sensor = 'CBSigmaOutput'; //Used for query
                }

            const data_results = await this.getDataInternal(device,this_sensor,nodeName, {preload:preload_flag});

            if(this.sensorDataQueryMap[device+'_'+sensor])
                this.sensorDataQueryMap[device+'_'+sensor].queryActive = false;

            if(data_results !== undefined && data_results.length > 0){
                if(preload_flag){
                    if (this.callbacks.onBulkMessage)
                        this.callbacks.onBulkMessage(data_results);
                } else {
                    if (this.callbacks.onMessage)
                        this.callbacks.onMessage(data_results);
                }
            }

        } catch (err) {
            console.log(err)
            if(this.sensorDataQueryMap[device+'_'+sensor])
                this.sensorDataQueryMap[device+'_'+sensor].queryActive = false;

            this.cancel = true;
            //this.token = this.iterator = null;
            this.token = null;
            this.disconnect();
            if (this.callbacks.onDisconnect)
                this.callbacks.onDisconnect(StreamType.DATA);
        }
    }


    private async health_loop() {
        try {
            //if (this.token === null)
            //    await this.connectInternal();

            if (this.callbacks.onConnect)
                this.callbacks.onConnect(StreamType.HEALTH);

            while (!this.cancel) {

                const health_results = await this.getHealthInternal();
                if (this.callbacks.onHealthMessage)
                    if(health_results){
                        this.callbacks.onHealthMessage(health_results);
                    }
                if (this.delay == 0)
                    await new Promise(r => setTimeout(r, 5000));

            }
        } catch (err) {
            console.log(err)
            this.cancel = true;
            //this.token = this.iterator = null;
            this.token = null;
            this.disconnect();
            if (this.callbacks.onDisconnect)
                this.callbacks.onDisconnect(StreamType.HEALTH);
        }
    }

    private async encounter_loop() {
        try {
            //if (this.token === null)
            //    await this.connectInternal();

            if (this.callbacks.onConnect)
                this.callbacks.onConnect(StreamType.ENCOUNTER);

            while (!this.cancel) {
                const encounter_results = await this.getEncounterInternal();
                if (this.callbacks.onMessage)
                    if(encounter_results){
                        this.callbacks.onMessage(encounter_results);
                    }
                if (this.delay == 0)
                    await new Promise(r => setTimeout(r, 5000));
            }
        } catch (err) {

            console.log(err)
            this.cancel = true;
            //this.token = this.iterator = null;
            this.token = null;
            this.disconnect();
            if (this.callbacks.onDisconnect)
                this.callbacks.onDisconnect(StreamType.ENCOUNTER);

        }
    }

    private async location_loop() {
        try {
            //if (this.token === null)
            //    await this.connectInternal();

            if (this.callbacks.onConnect)
                this.callbacks.onConnect(StreamType.LOCATION);

            while (!this.cancel) {

                const location_results = await this.getLocationInternal();
                if (this.callbacks.onLocationMessage)
                    if(location_results){
                        console.log('Location update complete', Date.now());
                        this.callbacks.onLocationMessage(location_results);
                    }
                if (this.delay == 0)
                    await new Promise(r => setTimeout(r, 5000));

            }
        } catch (err) {

            console.log(err)
            this.cancel = true;
            //this.token = this.iterator = null;
            this.token = null;
            this.disconnect();
            if (this.callbacks.onDisconnect)
                this.callbacks.onDisconnect(StreamType.LOCATION);

        }
    }

    private async dose_map_loop() {
        try {
            //if (this.token === null)
            //    await this.connectInternal();

            if (this.callbacks.onConnect)
                this.callbacks.onConnect(StreamType.DOSE_MAP);

            while (!this.cancel) {
                //console.log('dose_map_looping')
                //Get Live Dose Map
                if(this.doseMapLive === true){
                    let dose_map_result = await this.getDoseMapInternal('A');
                    //let dose_map_result = await this.getDoseMapInternal();
                    if (this.callbacks.onDoseMapMessage)
                        if(dose_map_result != undefined){
                            //if('doseMap' in dose_map_result){
                                this.callbacks.onDoseMapMessage(dose_map_result,'A');
                            //}
                        }
                    if (this.delay == 0)
                        await new Promise(r => {
                            this.doseMapLoopTimer = setTimeout(r, 60000);
                            if(this.doseMapLoadAborted){
                                clearTimeout(this.doseMapLoopTimer)
                            }
                        });   //Dose map query every 60 sec
                } else {
                    if (this.delay == 0)
                        await new Promise(r => {this.doseMapLoopTimer =setTimeout(r, 2000)});   //Dose map query every 2 sec for standby ready
                }
            }
            this.stream_promise = null;
        } catch (err:unknown) {
            console.log(err)
            if (err instanceof Error && err.name === 'AbortError') {
                console.log('User dose_map_loop Abort')
                this.stream_promise = null;
                //this.cancel = true;
                //this.dose_map_loop();
            } else {
                console.log(err)
                this.cancel = true;
                //this.stream_promise = null;
                //this.token = this.iterator = null;
                this.token = null;
                this.disconnect();
                if (this.callbacks.onDisconnect)
                    this.callbacks.onDisconnect(StreamType.DOSE_MAP);
            }
        }
    }


    async queryEncounter(query_start_timestamp?:number, query_end_timestamp?:number,return_last_encounter_only?:boolean):Promise<messages.Encounter.Encounter[]|undefined> {
        if(return_last_encounter_only === undefined){
            return_last_encounter_only = false;
        }

        if(this.streamType === StreamType.ENCOUNTER){
            if(this.initQueried == false){
                this.initQueried = true;
                let encounter_results;
                if(return_last_encounter_only){
                    encounter_results = await this.getEncounterSummary(query_start_timestamp,query_end_timestamp);
                } else {
                    encounter_results = await this.getEncounterInternal(query_start_timestamp,query_end_timestamp);
                }

                //Parse encounter results for newest for each encounter
                if( encounter_results !== undefined) {
                    let encounter_map:{[key:string]:DataPacket} = {};
                    encounter_results.forEach((this_packet,packet_idx) => {
                        let [this_header, this_message] = this_packet;
                        if(this_message !== null){
                            if(messages.Encounter.Encounter.prototype.isPrototypeOf(this_message)){
                                let this_inv = this_message as messages.Encounter.Encounter;
                                if(encounter_map[uuidToString(this_inv.id)] === undefined){
                                    encounter_map[uuidToString(this_inv.id)]  = this_packet;
                                } else {
                                    let [last_header, last_message] = encounter_map[uuidToString(this_inv.id)];
                                    if(last_message !== null){
                                        let last_inv = last_message as messages.Encounter.Encounter;
                                        if (this_inv.end_time >= last_inv.end_time) {
                                            encounter_map[uuidToString(this_inv.id)]  = this_packet;
                                        }
                                    }
                                }
                            }
                        }
                    });
                    encounter_results = Object.values(encounter_map);
                }
                if(encounter_results !== undefined){
                    console.log('Received '+encounter_results.length+' Unique Encounters')

                    //Convert to array of encounters
                    let encounters: messages.Encounter.Encounter[] = [];
                    encounter_results.forEach(encounter_result => {
                        let [header, message] = encounter_result;
                        if(message !== null){
                            if(messages.Encounter.Encounter.prototype.isPrototypeOf(message)){
                                let enc = message as messages.Encounter.Encounter;
                                enc.node_name = header.device_name;
                                encounters.push(enc);
                            }
                        }
                    });
                    return(encounters)
                }

                /*
                if (this.callbacks.onMessage){
                    if(encounter_results){
                        this.callbacks.onMessage(encounter_results);
                    }
                }
                */
            } else {
                console.log('Already initialized')
            }
        }
    }

    async queryEncounterData(inv: messages.Encounter.Encounter, padding: number) :Promise<{[key:string]:Device} | undefined> {
        let plottableSensorReadings:{[key: string]:PlottableSensorReading[]} = {};//PlottableSensorReading[]
        let metReadings:METReading[] = [];
        let gpsReadings:GPSReading[] = [];
        let algorithmResults: {[key:string]: AlgorithmResult[]} = {};

        let devices:{[key:string]:Device} = {};

        if(this.streamType !== StreamType.DATA){
            return;
        }

        let start_time = inv.start_time - padding;
        let end_time = inv.end_time + padding;

        if(inv.type === messages.Encounter.EncounterType.BIOSIGMA || messages.Encounter.EncounterType.CHEMSIGMA){
            const this_device = 'PSI';
            const this_sensor = 'CBSigmaOutput'; //Used for query
            const this_sensor_no_hyphen = 'PSI CBSIGMA'
            const this_nodeName = 'NETWORK'; //BD21DataStream.remapDeviceName(inv.node_name)

            let data_results;
            const key = this_device+this_sensor+start_time+end_time;
            if(Object.keys(this.sensorReplayDataQueryActiveMap).includes(key)){
                console.log(key+' is being queried already')
            } else {
                this.sensorReplayDataQueryActiveMap[key] = new Date().getTime();

                data_results = await this.getDataInternal(this_device, this_sensor, this_nodeName, {queryStartTimestamp:start_time,queryEndTimestamp:end_time})
                console.log('Query took '+(new Date().getTime() - this.sensorReplayDataQueryActiveMap[key])/1000+' sec');

                delete this.sensorReplayDataQueryActiveMap[key];
            }
            //const data_results = await this.getDataInternal(this_device, this_sensor, this_nodeName, {queryStartTimestamp:start_time,queryEndTimestamp:end_time})

            console.log(data_results);
            if(data_results !== undefined){
                let this_cbsigma_data: PlottableSensorReading[] = [];
                let deviceName = '';
                let sensorName = '';
                data_results.forEach((packet) => {
                    let [header, message] = packet;
                    if(message !== null){
                        if ('device' in message && PlottableSensorReading.prototype.isPrototypeOf(message)){
                            if (message.device !== undefined) {
                                deviceName = message.device;
                                sensorName = message.sensor;
                                this_cbsigma_data.push(message as PlottableSensorReading);
                            }
                        }
                    }
                });
                if(this_cbsigma_data.length > 0){
                    plottableSensorReadings[sensorName] = this_cbsigma_data;
                    console.log('deviceName: '+deviceName)
                    if (devices[deviceName] === undefined) {
                        devices[deviceName] = new Device(deviceName);
                    }
                    devices[deviceName].plottableSensorReadings = plottableSensorReadings;
                    devices[deviceName].dataStatus[sensorName]="";
                } else {
                    console.log('this_device: '+this_device)
                    if (devices[this_device] === undefined) {
                        devices[this_device] = new Device(this_device);
                    }
                    devices[this_device].dataStatus[this_sensor_no_hyphen]="No Data Found";
                }
            }
            return devices;

        } else {
            if(inv.alarming_sensors === undefined || inv.alarming_sensors === null)
                return;

            //Node level alert recall
            for(const alarming_sensor of inv.alarming_sensors){
                const this_device = inv.node_name;
                const this_sensor = alarming_sensor.make+'-'+alarming_sensor.model
                const this_sensor_no_hyphen = alarming_sensor.make+' '+alarming_sensor.model
                const this_nodeName = BD21DataStream.remapDeviceName(inv.node_name);
                //for each sensors query data

                //Initialize sensorDataQueryMap
                //const device_sensor = this_device+'_'+this_sensor+'_replay';
                //this.sensorReplayDataQueryMap[device_sensor] = {device:this_device, sensor:this_sensor, lastDataTimestamp:0};

                const data_results = await this.getDataInternal(this_device, this_sensor, this_nodeName, {queryStartTimestamp:start_time,queryEndTimestamp:end_time})

                if(data_results !== undefined){
                    let this_bio_data: PlottableSensorReading[] = [];
                    let deviceName = '';
                    let sensorName = '';
                    data_results.forEach((packet) => {
                        let [header, message] = packet;
                        if(message !== null){
                            if ('device' in message && PlottableSensorReading.prototype.isPrototypeOf(message)){
                                if (message.device !== undefined) {
                                    deviceName = message.device;
                                    sensorName = message.sensor;

                                    this_bio_data.push(message as PlottableSensorReading);
                                }
                            }
                        }
                    });
                    if(this_bio_data.length > 0){
                        plottableSensorReadings[sensorName] = this_bio_data;
                        console.log('deviceName: '+this_device)
                        if (devices[deviceName] === undefined) {
                            devices[deviceName] = new Device(deviceName);
                        }
                        devices[deviceName].plottableSensorReadings = plottableSensorReadings;
                        devices[deviceName].dataStatus[sensorName]="";
                    } else {
                        console.log('this_device: '+this_device)
                        if (devices[this_device] === undefined) {
                            devices[this_device] = new Device(this_device);
                        }
                        devices[this_device].dataStatus[this_sensor_no_hyphen]="No Data Found";
                    }
                }
            };

            console.log('all sensors queried');
            //const dataset = new Dataset(plottableSensorReadings,metReadings,gpsReadings,algorithmResults);
            //return dataset;
            return devices;
        }

    }

    async queryHistoricalData(device:string, sensor:string, nodeName:string, sensor_no_hyphen: string, queryStartTimestamp:number, queryEndTimestamp:number):Promise<{[key:string]:Device} | undefined>{
        try {
            let plottableSensorReadings:{[key: string]:PlottableSensorReading[]} = {};//PlottableSensorReading[]

            let data_results;
            const key = device+sensor+queryStartTimestamp+queryEndTimestamp;
            if(Object.keys(this.sensorReplayDataQueryActiveMap).includes(key)){
                console.log(key+' is being queried already')
            } else {
                this.sensorReplayDataQueryActiveMap[key] = new Date().getTime();

                data_results = await this.getDataInternal(device,sensor,nodeName, {queryStartTimestamp:queryStartTimestamp,queryEndTimestamp:queryEndTimestamp});
                console.log('Query took '+(new Date().getTime() - this.sensorReplayDataQueryActiveMap[key])/1000+' sec');

                delete this.sensorReplayDataQueryActiveMap[key];
            }

            let devices:{[key:string]:Device} = {};


            if(data_results !== undefined){
                let this_bio_data: PlottableSensorReading[] = [];
                let deviceName = '';
                let sensorName = '';
                let headerStatusString = '';
                data_results.forEach((packet) => {
                    let [header, message] = packet;
                    if(message !== null){
                        if ('device' in message && PlottableSensorReading.prototype.isPrototypeOf(message)){
                            if (message.device !== undefined) {
                                deviceName = message.device;
                                sensorName = message.sensor;

                                this_bio_data.push(message as PlottableSensorReading);
                            }
                        }
                    }
                    if(header.statusString === 'LOADING'){
                        headerStatusString = header.statusString;
                    }
                });
                if(this_bio_data.length > 0){
                    plottableSensorReadings[sensorName] = this_bio_data;
                    console.log('deviceName: '+deviceName)
                    if (devices[deviceName] === undefined) {
                        devices[deviceName] = new Device(deviceName);
                    }
                    devices[deviceName].plottableSensorReadings = plottableSensorReadings;
                    devices[deviceName].dataStatus[sensorName]="";
                } else {
                    console.log('this_device: '+nodeName)
                    if (devices[nodeName] === undefined) {
                        devices[nodeName] = new Device(nodeName);
                    }
                    console.log('sensor_no_hyphen: '+sensor_no_hyphen)
                    if(headerStatusString === "LOADING"){
                        devices[nodeName].dataStatus[sensor_no_hyphen]="Loading...";
                    } else {
                        devices[nodeName].dataStatus[sensor_no_hyphen]="No Data Found";
                    }
                }
            }

            console.log('all sensors queried');
            //const dataset = new Dataset(plottableSensorReadings,metReadings,gpsReadings,algorithmResults);
            //return dataset;
            return devices;


        } catch (err) {
            console.log(err)
            this.cancel = true;
            //this.token = this.iterator = null;
            this.token = null;
            this.disconnect();
            if (this.callbacks.onDisconnect)
                this.callbacks.onDisconnect(StreamType.DATA);
        }
    }

    async queryCloudN42(device: string, uuid:string, timestamp:number, timeout: number = 60000) : Promise<string|undefined> {

        console.log('queryCloudN42 '+uuid)

        let time_string = this.convertTimestampToQueryTimestring(timestamp);

        //let getdata_string = '/data?type=N42&time='+time_string+'&device='+device+'&uuid='+uuid;
        let getdata_string = '/context_image?type=n42-summed&time='+time_string+'&device='+device+'&uuid='+uuid;
        console.log(getdata_string)
        // getdata_string = '/context_image?type=n42-summed&time=20241219000000&device=OWL-0042&uuid=testa'
        try{
            if (this.token === null)
                throw new Error("Connection failure");

            let response = await fetch(BD21DataStream.endpoint + getdata_string, {
                headers: {
                   Authorization: this.token,
                }
            });

            console.log(response);

            let data = await response.json();

            //console.log(data);

            if(data.data.includes('Error')){
                //if(this_end_timestamp + data_chunk_timespan > end_timestamp){
                //console.log('Data replied with: ' +data.data);
                let statusString = '';
                if (data.data.includes('No Data found')){
                    //statusString = 'No Data Available'
                    console.log('No Data Found')
                    //statusString = "No Data Found"
                } else if (data.data.includes('list index out of range')){
                    //statusString = 'No Data in range queried'
                    console.log('list index out of range')
                    //statusString = "No Data Found"
                }
                return undefined;
            } else {
                //NO ERROR

                const n42_decoded = atob(data.data);
                console.log(n42_decoded)
                return n42_decoded;
            }
        } catch (err) {
            console.log(err)
            return undefined;
        }
    }

    async dummy_n42_query(uuid:string):Promise<string>{
        return new Promise(resolve => setTimeout(()=>{resolve('this is the N42 dummy text for uuid='+uuid)}, 3000));
    }

    async getHealthInternal(): Promise<messages.Core.GroupedHealthMessage|undefined> {
        if (this.token === null)
            throw new Error("Connection failure");
        let gethealth_string = '/health/';
        let response = await fetch(BD21DataStream.endpoint + gethealth_string, {
            headers: {
               Authorization: this.token
            }

        });
        //console.log(response);

        let data = await response.json();

        //console.log(data);
        if(data.data.includes('Error')){
            console.error('Health replied with: ' +data.data);
            return;
        } else {
            const thrift_data = data.data[0];
            const typed_data = Buffer.from(thrift_data,'base64');
            const transport = new thrift.TFramedTransport(typed_data);
            const protocol = new thrift.TBinaryProtocol(transport);
            let health_message = new messages.Core.GroupedHealthMessage();
            health_message.read(protocol);

            return health_message;
        }
    }

    /**************************************************************************/
    //Dose Map Queries

    abortDoseMapQuery(key:string){
        if(this.doseMapAbortController[key]){
            this.doseMapAbortController[key].abort();
            delete this.doseMapAbortController[key];
        }
    }

    async getDoseMapInternal(key: string, histDate?:string): Promise<DoseMapMessage|undefined> {

        this.doseMapAbortController[key] = new AbortController();
        const signal = this.doseMapAbortController[key].signal;
        this.doseMapLoadAborted = false;

        let previous_manifest;
        if(this.lastLiveDoseMapManifest[key] && this.lastLiveDoseMapManifest[key].manifest !== undefined) {
            previous_manifest = JSON.parse(this.lastLiveDoseMapManifest[key]!.manifest!);
        }

        if (this.token === null)
            throw new Error("Connection failure");
        let getdosemap_string = '/dose_image?file=manifest.json';
        if(histDate){
            getdosemap_string +='&hist_date='+histDate;
        }

        let response = await fetch(BD21DataStream.endpoint + getdosemap_string, { signal,
            headers: {
               Authorization: this.token
            }
        });
        console.log(response);

        let data = await response.json();

        console.log(data);

        if(data.data.includes('Error')){
            console.error('Dose Map replied with: ' +data.data);
            if(this.callbacks.onDoseMapLoadProgress)
                this.callbacks.onDoseMapLoadProgress(key,false,-1);
            return;
        } else {
            let dose_map_message:DoseMapMessage = { regions: [],
                time: null,
                lastUpdatedTime: null,
                displayScaleVal: {[DoseDatatype.DOSE_RATE]:{min:null,max:null},[DoseDatatype.MAX_DOSE_RATE]:{min:null,max:null},[DoseDatatype.UNCERTAINTY]:{min:null,max:null}},
                globalScaleVal: {[DoseDatatype.DOSE_RATE]:{min:null,max:null},[DoseDatatype.MAX_DOSE_RATE]:{min:null,max:null},[DoseDatatype.UNCERTAINTY]:{min:null,max:null}},
                dataScaleVal: {[DoseDatatype.DOSE_RATE]:{min:null,max:null},[DoseDatatype.MAX_DOSE_RATE]:{min:null,max:null},[DoseDatatype.UNCERTAINTY]:{min:null,max:null}},
            };

            let regions_total=0;
            let regions_skipped=0;
            let regions_updated=0;
            if (data.data !== undefined && Array.isArray(data.data)){
                 //data.data.forEach( (msg:string,idx:number) => {
                 for (const msg of data.data) {
                     if(!msg.includes('manifest.json')){
                            let manifest = JSON.parse(msg);
                            //console.log(manifest);
                            dose_map_message.manifest = msg;
                            dose_map_message.time = manifest.time;
                            this.lastLiveDoseMapManifest[key].manifest = msg;

                            let map_changed = false;
                            if (manifest.regions !== undefined && Array.isArray(manifest.regions)){
                                 //manifest.regions.forEach((region:any,idx:number) => {
                                 const regions_total =  manifest.regions.length;
                                 let regions_index = 0;

                                 let query_promises = [];

                                 let abort_signal = false;
                                 for(const region of manifest.regions){

                                    if (this.token === null)
                                        throw new Error("Connection failure");

                                    let query_this_region = true;

                                    if (region.id in this.doseImageMap && region.time_updated <= this.doseImageMap[region.id]) {
                                        let oldRegion = this.doseMapRegions[region.id];
                                        let regionCopy: TiledDoseMapImage = {uuid: region.id,
                                            time: oldRegion.time,
                                            doseMap: oldRegion.doseMap,
                                            maxDoseMap: oldRegion.maxDoseMap,
                                            uncertMap: oldRegion.uncertMap,
                                            doseRaw: oldRegion.doseRaw,
                                            doseStdRaw: oldRegion.doseStdRaw,
                                            doseMaxRaw:oldRegion.doseMaxRaw,
                                            doseMaxStdRaw: oldRegion.doseMaxStdRaw,
                                            maskMap: oldRegion.maskMap,
                                            maskMax: oldRegion.maskMax,
                                            dataScaleVal: {[DoseDatatype.DOSE_RATE]:{min:null,max:null},[DoseDatatype.MAX_DOSE_RATE]:{min:null,max:null},[DoseDatatype.UNCERTAINTY]:{min:null,max:null}},
                                            npzBlob: oldRegion.npzBlob,
                                            swCorner: oldRegion.swCorner,
                                            neCorner: oldRegion.neCorner};

                                        dose_map_message.regions!.push(regionCopy);
                                        if(dose_map_message.lastUpdatedTime === null || (regionCopy.time !== null && dose_map_message.lastUpdatedTime < regionCopy.time)){
                                            dose_map_message.lastUpdatedTime = regionCopy.time;
                                        }

                                        continue;
                                    }

                                    //Async queries
                                    query_promises.push(new Promise<void>(async(resolve, reject) => {
                                        if(!abort_signal){
                                            try{
                                                if (this.token === null)    //This added for async loop
                                                    throw new Error("Connection failure");

                                                if(query_this_region){
                                                    //Query images
                                                    let getdosemap_string = '/dose_image?file='+region.id+'&npz=True';//+'&hist_date=20241106';
                                                    if(histDate){
                                                        getdosemap_string +='&hist_date='+histDate;
                                                    }

                                                    let npz_response = await fetch(BD21DataStream.endpoint + getdosemap_string, { signal,
                                                        headers: {
                                                           Authorization: this.token
                                                        }
                                                    });
                                                    //console.log(image_response);

                                                    let data = await npz_response.json();

                                                    //console.log(data);

                                                    let datatype = DoseDatatype.DOSE_RATE;
                                                    if(data.data.includes('Error')){
                                                        console.error('Dose Map replied with: ' +data.data);
                                                        //if(data.data.includes('No Data found')){
                                                        regions_skipped++;
                                                        //}
                                                        //return; //DONT RETURN IF QUERYING VIA MUTLIPLE PROMISES
                                                    } else {
                                                        if (data.data !== undefined && Array.isArray(data.data)){
                                                            let idx = 0;
                                                            for(const msg of data.data){
                                                            //data.data.forEach((msg:string,idx:number) => {
                                                                if(idx % 2 === 0){
                                                                    datatype = DoseDatatype.DOSE_RATE;
                                                                    if(msg.includes("_std.png")){
                                                                        datatype =  DoseDatatype.UNCERTAINTY;
                                                                    } else if (msg.includes("_max")){
                                                                        datatype = DoseDatatype.MAX_DOSE_RATE;
                                                                    }
                                                                } else {
                                                                    if(datatype === DoseDatatype.DOSE_RATE){ //N.B. it should only be one response with 1 npz with 6 arrays
                                                                        //Query returns base64 encoded image
                                                                        const npzDataBuffer = Buffer.from(msg, 'base64');
                                                                        await DoseMapUtility.loadNPZFromBuffer(npzDataBuffer).then((result)=>{
                                                                            //console.log("making dosemap message")
                                                                            //TODO FIX HACK HERE
                                                                            const doseMaxRaw = result.npzData['dose_max'];
                                                                            const doseMapRaw = result.npzData['dose_map'];
                                                                            const doseMapStdRaw = result.npzData['dose_map_std'];
                                                                            const doseMaxStdRaw = result.npzData['dose_max_std'];
                                                                            const maskMapRaw = result.npzData['mask_map'];
                                                                            const maskMaxRaw = result.npzData['mask_max'];
                                                                            const npzBlob = result.blob;
                                                                            const timeUpdated = region.time_updated;

                                                                            let thisRegion:TiledDoseMapImage = {uuid: region.id,
                                                                                          time: timeUpdated,
                                                                                          doseMap: null, //N.B. Updated later
                                                                                          maxDoseMap: null, //N.B. Updated later
                                                                                          uncertMap: null, //N.B. Updated later
                                                                                          doseRaw: doseMapRaw,
                                                                                          doseStdRaw: doseMapStdRaw,
                                                                                          doseMaxRaw:doseMaxRaw,
                                                                                          doseMaxStdRaw: doseMaxStdRaw,
                                                                                          maskMap: maskMapRaw,
                                                                                          maskMax: maskMaxRaw,
                                                                                          npzBlob: npzBlob,
                                                                                          dataScaleVal: {[DoseDatatype.DOSE_RATE]:{min:null,max:null},[DoseDatatype.MAX_DOSE_RATE]:{min:null,max:null},[DoseDatatype.UNCERTAINTY]:{min:null,max:null}},
                                                                                          swCorner: {lat:region.center.lat-(region.delta_lat/2.0),
                                                                                                     lon:region.center.lon-(region.delta_lon/2.0)},
                                                                                          neCorner: {lat:region.center.lat+(region.delta_lat/2.0),
                                                                                                     lon:region.center.lon+(region.delta_lon/2.0)}}

                                                                            //Calculate data statistics
                                                                            DoseMapUtility.updateDataStatisticsForRegion(thisRegion);

                                                                             this.doseMapRegions[region.id] = thisRegion;
                                                                             this.doseImageMap[region.id] = region.time_updated;

                                                                             const regionCopy: TiledDoseMapImage = {uuid: region.id,
                                                                                 time: thisRegion.time,
                                                                                 doseMap: thisRegion.doseMap,
                                                                                 maxDoseMap: thisRegion.maxDoseMap,
                                                                                 uncertMap: thisRegion.uncertMap,
                                                                                 doseRaw: thisRegion.doseRaw,
                                                                                 doseStdRaw: thisRegion.doseStdRaw,
                                                                                 doseMaxRaw:thisRegion.doseMaxRaw,
                                                                                 doseMaxStdRaw: thisRegion.doseMaxStdRaw,
                                                                                 maskMap: thisRegion.maskMap,
                                                                                 maskMax: thisRegion.maskMax,
                                                                                 npzBlob: thisRegion.npzBlob,
                                                                                 dataScaleVal: thisRegion.dataScaleVal,
                                                                                 swCorner: thisRegion.swCorner,
                                                                                 neCorner: thisRegion.neCorner};

                                                                             //console.log('adding region '+region.id)
                                                                             dose_map_message.regions!.push(regionCopy);
                                                                             if(dose_map_message.lastUpdatedTime === null || (regionCopy.time !== null && dose_map_message.lastUpdatedTime < regionCopy.time)){
                                                                                 dose_map_message.lastUpdatedTime = regionCopy.time;
                                                                             }

                                                                        });
                                                                        regions_updated++;
                                                                        map_changed = true;
                                                                    }
                                                                }
                                                                idx++;
                                                            }
                                                        }
                                                    }
                                                }
                                                //regions_index++;
                                                resolve(); //This returns the result


                                            } catch (err) {
                                                if (err instanceof Error && err.name === 'AbortError') {
                                                    console.log('User Abort Query')
                                                    this.doseMapLoadAborted = true;
                                                }
                                                reject(err)

                                            }
                                        }
                                    }).catch(error =>{
                                        //N.B. Need this error catch for abort error
                                    })); //promises
                                }//end regions
                                //console.log('returning dosmap_message'+dose_map_message)

                                const results = [];
                                const executing = [];
                                let concurrent_limit = 1;
                                let query_index = 0;
                                let query_total = query_promises.length;
                                if(query_total > 0){
                                    for (const task of query_promises) {
                                        if(!abort_signal){
                                            const promise = task; // Execute the task and get a promise

                                            executing.push(promise);

                                            if (executing.length >= concurrent_limit) {
                                                //Update progress
                                                if(this.callbacks.onDoseMapLoadProgress){
                                                    const percent = Math.floor((query_index/query_total)*100);
                                                    //console.log('Progress '+percent)
                                                    this.callbacks.onDoseMapLoadProgress(key,true,percent);
                                                }

                                                await Promise.race(executing)
                                                //console.log('adding '+query_index)

                                                query_index++;
                                                executing.splice(executing.indexOf(promise), 1); // Remove the resolved promise from the executing array
                                            }

                                            results.push(await promise); // Store the result of the task
                                        }
                                    }
                                }

                                if(this.callbacks.onDoseMapLoadProgress !== undefined){
                                    this.callbacks.onDoseMapLoadProgress(key,false,-1);
                                }

                                console.log('Total Regions: '+regions_total+' Updated: '+regions_updated+' Skipped: '+regions_skipped)
                                if(map_changed){
                                    console.log('map changed')
                                }

                            }
                        } //Skip filename "manifest.json"
                    }
            }

            console.log('returning dosmap_message from cloud');
            console.log('doseMapLoadAborted: '+this.doseMapLoadAborted)
            console.log(dose_map_message);

            //N.B data statistics and images updated externally
            //dose_map_message = DoseMapUtility.updateDataStatistics(dose_map_message);
            //dose_map_message = DoseMapUtility.updateDoseMaps(dose_map_message);
            if(this.doseMapLoadAborted){
                console.log('returning UNDEFINED for dose_map_message because query was aborted');
                this.doseMapLoadAborted = false; //N.B. Reset so the subsequent map loads are returned
                return undefined
            } else {
                return dose_map_message;
            }

        }
    }

    async getDoseMapFromHistory(key: string, hist_date:string): Promise<void|undefined> {

        try {
            if (this.token === null)
                throw new Error("Connection failure");

            //Parse hist_date string [YYYYMMDD]
            if(hist_date !== ""){
                const thisYear = Number(hist_date.substring(0,4));
                const thisMonth = Number(hist_date.substring(4,6));
                const thisDay = Number(hist_date.substring(6,8));

                let dose_map_result = await this.getDoseMapInternal(key,hist_date);

                if (this.callbacks.onDoseMapMessage)
                    if(dose_map_result != undefined){
                        //if('doseMap' in dose_map_result){
                            this.callbacks.onDoseMapMessage(dose_map_result,key);
                        //}
                    }
            }
        } catch (err:unknown) {
            if (err instanceof Error && err.name === 'AbortError') {
                console.log('User Abort Query')
            } else {
                console.log(err)
            }
        }
    }


    async getDoseMapSummary(): Promise<string[]|undefined> {
        if (this.token === null)
            throw new Error("Connection failure");
        let getdosemap_string = '/dose_image?datelist=True';

        let response = await fetch(BD21DataStream.endpoint + getdosemap_string, {
            headers: {
               Authorization: this.token
            }
        });
        //console.log(response);

        let data = await response.json();

        if(data.data.includes('Error')){
            console.error('Dose Map summary replied with: ' +data.data);
            return;
        } else {
            console.log(data);
            let summarystring:string[] = [];
            data.data.forEach((element:string) => {
                summarystring.push(element);
            });
            summarystring.sort((a, b) => {
              return parseInt(b) - parseInt(a);
            });
            /*
            data.data.forEach((element:String) => {
                const thisYear = Number(element.substring(0,4));
                const thisMonth = Number(element.substring(4,6));
                const thisDay = Number(element.substring(6,8));
                let thisDate =  new Date();
                thisDate.setUTCFullYear(thisYear,thisMonth-1,thisDay);
                thisDate.setUTCHours(5,0,0,0);
                const thisDateNumberString = thisDate.getTime().toFixed();
                console.log(thisDateNumberString);
                summarystring.push(thisDateNumberString)
            });
            */
            return summarystring;
        }
    }

    async getEncounterSummary(query_start_timestamp?:number, query_end_timestamp?:number): Promise<DataPacket[]|undefined> {
        if (this.token === null)
            throw new Error("Connection failure");

        let datapacket_messages: DataPacket[] = [];

        if( query_end_timestamp === undefined){
            query_end_timestamp = Date.now()-(this.realtime_query_offet*1000);
        }
        if(query_start_timestamp === undefined){
            query_start_timestamp = query_end_timestamp-24*3600*1000;
        }

        let start_time_string = this.convertTimestampToQueryTimestring(query_start_timestamp);
        let end_time_string = this.convertTimestampToQueryTimestring(query_end_timestamp);

        let getencounter_string = '/alarms/?start_time='+start_time_string+'&end_time='+end_time_string+'&last_only=True';
        //getencounter_string = "/alarms/?start_time=20240503174037882&end_time=20240503174047882"+"&last_only=True";
        if(this.getTier0_2_Results){
            getencounter_string += '&getT0_2=True';
        }
        let response = await fetch(BD21DataStream.endpoint + getencounter_string, {
            headers: {
               Authorization: this.token
            }

        });

        let data = await response.json();

        if(data.data.includes('Error')){
            //if(query_start_timestamp !== undefined){
            //    console.error('Encounter replied with: ' +data.data);
            //}
            //if(query_start_timestamp !== undefined && query_end_timestamp !== undefined)
            //    return;
        } else {
            //let datapacket_messages: DataPacket[] = [];
            let header:messages.Core.ExternalSensorMessageHeader|null = null;
            if (data.data !== undefined && Array.isArray(data.data)){
                data.data.forEach((msg:string,idx:number) => {
                    if(idx % 2 === 0){
                        //Even messages are headers
                        const typed_data = Buffer.from(msg, 'base64');
                        const transport = new thrift.TFramedTransport(typed_data);
                        const protocol = new thrift.TBinaryProtocol(transport);
                        header = new messages.Core.ExternalSensorMessageHeader();
                        header.read(protocol);

                    } else {
                        //Odd messages are data of topic defined in header
                        let parsed_data;
                        if(header !== null){
                            const typed_data2 = Buffer.from(msg, 'base64');
                            const transport2 = new thrift.TFramedTransport(typed_data2);
                            const protocol2 = new thrift.TBinaryProtocol(transport2);
                            if (header.topic === messages.Encounter.EncounterTopic) {
                                let encounter_message = new messages.Encounter.Encounter;
                                encounter_message.read(protocol2);

                                const timestamp = parseInt(encounter_message.start_time.toString());
                                const datapacket_header = { timestamp: header.time.toString(), device_name: header.device_name, vendor: 'PSI', statusString:''};
                                if (parsed_data !== null)
                                    datapacket_messages.push([datapacket_header, encounter_message]);
                                //console.log(encounter_message);
                            } else if (header.topic === messages.Rad.InvestigationTopic) {
                                let inv_message = new messages.Rad.Investigation;
                                inv_message.read(protocol2);
                                //console.log('Converting Investigation message '+ uuidToString(inv_message.id))
                                let conv_encounter_message = invToEncounter(inv_message); //Convert to Encounter

                                const timestamp = parseInt(conv_encounter_message.start_time.toString());
                                const datapacket_header = { timestamp: header.time.toString(), device_name: header.device_name, vendor: 'PSI', statusString:''};
                                if (parsed_data !== null)
                                    datapacket_messages.push([datapacket_header, conv_encounter_message]);
                            }
                        }
                    }
                });
                console.log('Received '+datapacket_messages.length+' New Encounter msgs between '+query_start_timestamp+' and '+query_end_timestamp)
            }
            //console.log(datapacket_messages);
            //return datapacket_messages;
        } //else

        return datapacket_messages;
    }

    async getEncounterInternal(query_start_timestamp?:number, query_end_timestamp?:number): Promise<DataPacket[]|undefined> {

        const data_chunk_timespan = 18*1000; //ms
        const max_lookback_timespan = 60000; //ms
        if (this.token === null)
            throw new Error("Connection failure");

        let end_timestamp;
        let start_timestamp;
        if(query_start_timestamp !== undefined && query_end_timestamp !== undefined){
            //Specified by input arguement
            end_timestamp = query_end_timestamp;
            start_timestamp = query_start_timestamp
        } else {
            //Real time
            end_timestamp = Date.now()-(this.realtime_query_offet*1000);
            //console.log("lastLiveEncounterDataTimestamp "+this.lastLiveEncounterDataTimestamp)
            if(this.lastLiveEncounterDataTimestamp > end_timestamp-max_lookback_timespan){
                start_timestamp = this.lastLiveEncounterDataTimestamp;
            } else {
                //Data is older than max lookback time so trunkate to max lookback time
                start_timestamp = end_timestamp-max_lookback_timespan;
            }

        }

        let this_start_timestamp = start_timestamp;
        let this_end_timestamp = start_timestamp + data_chunk_timespan;
        if(this_end_timestamp > end_timestamp){
            this_end_timestamp = end_timestamp;
        }

        let datapacket_messages: DataPacket[] = [];
        //Load data in max 10 second chunks
        let do_loop_flag = true;
        let loop_count = 0;
        while (do_loop_flag) {

            let start_time_string = this.convertTimestampToQueryTimestring(this_start_timestamp);
            let end_time_string = this.convertTimestampToQueryTimestring(this_end_timestamp);

            //console.log('Querying between '+start_time_string+' and '+end_time_string+' ('+(this_end_timestamp-this_start_timestamp)+'ms)');
            let getencounter_string = '/alarms/?start_time='+start_time_string+'&end_time='+end_time_string;//+'&last_only=True';
            if(this.getTier0_2_Results){
                getencounter_string += '&getT0_2=True';
            }

            let response = await fetch(BD21DataStream.endpoint + getencounter_string, {
                headers: {
                   Authorization: this.token
                }

            });

            let data = await response.json();

            if(data.data.includes('Error')){
                //if(query_start_timestamp !== undefined){
                //    console.error('Encounter replied with: ' +data.data);
                //}
                //if(query_start_timestamp !== undefined && query_end_timestamp !== undefined)
                //    return;
            } else {
                //let datapacket_messages: DataPacket[] = [];
                let header:messages.Core.ExternalSensorMessageHeader|null = null;
                if (data.data !== undefined && Array.isArray(data.data)){
                    data.data.forEach((msg:string,idx:number) => {
                        if(idx % 2 === 0){
                            //Even messages are headers
                            const typed_data = Buffer.from(msg, 'base64');
                            const transport = new thrift.TFramedTransport(typed_data);
                            const protocol = new thrift.TBinaryProtocol(transport);
                            header = new messages.Core.ExternalSensorMessageHeader();
                            header.read(protocol);

                        } else {
                            //Odd messages are data of topic defined in header
                            let parsed_data;
                            if(header !== null){
                                const typed_data2 = Buffer.from(msg, 'base64');
                                const transport2 = new thrift.TFramedTransport(typed_data2);
                                const protocol2 = new thrift.TBinaryProtocol(transport2);
                                if (header.topic === messages.Encounter.EncounterTopic) {
                                    let encounter_message = new messages.Encounter.Encounter;
                                    encounter_message.read(protocol2);

                                    const timestamp = parseInt(encounter_message.start_time.toString());
                                    const header_timestamp = parseInt(header.time.toString());
                                    if(header_timestamp > this.lastLiveEncounterDataTimestamp){
                                        //Data is newer than last data
                                        this.lastLiveEncounterDataTimestamp = header_timestamp;

                                        //HACK FOR BD21
                                        const datapacket_header = { timestamp: header.time.toString(), device_name: BD21DataStream.remapDeviceName(header.device_name), vendor: 'PSI', statusString:''};
                                        //const datapacket_header = { timestamp: header.time.toString(), device_name: header.device_name, vendor: 'PSI', statusString:''};
                                        if (parsed_data !== null)
                                            datapacket_messages.push([datapacket_header, encounter_message]);
                                    }
                                    //console.log(encounter_message);
                                } else if (header.topic === messages.Rad.InvestigationTopic) {
                                    let inv_message = new messages.Rad.Investigation;
                                    inv_message.read(protocol2);
                                    console.log('Converting Investigation message '+ uuidToString(inv_message.id))
                                    let conv_encounter_message = invToEncounter(inv_message); //Convert to Encounter

                                    const timestamp = parseInt(conv_encounter_message.start_time.toString());
                                    const header_timestamp = parseInt(header.time.toString());
                                    if(header_timestamp > this.lastLiveEncounterDataTimestamp){
                                        //Data is newer than last data
                                        this.lastLiveEncounterDataTimestamp = header_timestamp;
                                        //console.log('***header time:'+header.time.toString())

                                        //HACK FOR BD21
                                        const datapacket_header = { timestamp: header.time.toString(), device_name: BD21DataStream.remapDeviceName(header.device_name), vendor: 'PSI', statusString:''};
                                        //const datapacket_header = { timestamp: header.time.toString(), device_name: header.device_name, vendor: 'PSI', statusString:''};
                                        if (parsed_data !== null)
                                            datapacket_messages.push([datapacket_header, conv_encounter_message]);
                                    }
                                }
                            }
                        }
                    });
                    console.log('Received '+datapacket_messages.length+' Encounter msgs between '+this_start_timestamp+' and '+this_end_timestamp)
                }
                //console.log(datapacket_messages);
                //return datapacket_messages;
            } //else
            this_start_timestamp = this_end_timestamp+1;
            this_end_timestamp = this_start_timestamp + data_chunk_timespan;
            if(this_end_timestamp > end_timestamp){
                this_end_timestamp =  end_timestamp;
            }
            if(this_start_timestamp > end_timestamp){
                do_loop_flag = false;
            }
            loop_count += 1;
        }
        //console.log('Encounter Query loop count:'+loop_count)
        //console.log(datapacket_messages)
        return datapacket_messages;
    }

    async getLocationInternal(query_start_timestamp?:number, query_end_timestamp?:number): Promise<GroupedLocationMessage|undefined> {

        const lookback_timespan = 10000; //ms

        if (this.token === null)
            throw new Error("Connection failure");

        //Real Time
        const end_timestamp = Date.now()-(this.realtime_query_offet*1000);
        let start_timestamp;
        //console.log("lastLiveLocationQueryTimestamp "+this.lastLiveLocationQueryTimestamp)
        if(this.lastLiveLocationQueryTimestamp >= end_timestamp-lookback_timespan){
            //last Live location query was less than 10 sec
            start_timestamp = this.lastLiveLocationQueryTimestamp;
        } else {
            start_timestamp = end_timestamp-lookback_timespan;
        }
        this.lastLiveLocationQueryTimestamp = start_timestamp;

        const start_time_string = this.convertTimestampToQueryTimestring(start_timestamp);
        const end_time_string = this.convertTimestampToQueryTimestring(end_timestamp);

        let getlocation_string = '/location/?start_time='+start_time_string+'&end_time='+end_time_string;
        let response = await fetch(BD21DataStream.endpoint + getlocation_string, {
            headers: {
               Authorization: this.token
            }

        });
        let data = await response.json();
        if(data.data.includes('Error')){
            //console.error('Location replied with: ' +data.data);
            return;
        } else {

            let location_message: GroupedLocationMessage = {};
            if (data.data !== undefined){
                //const json_str = data.data.replace(/'/g,'"').replace(/False/g,'null');
                let json_str = data.data;
                if(String(API_ROOT.Endpoint).includes("lbhrbcrzci")) //THIS IS A HACK FOR BD21 STREAM
                    json_str = data.data.replace(/'/g,'"').replace(/False/g,'null');
                const parsed_loc_msg = JSON.parse(json_str);
                Object.entries(parsed_loc_msg).map(entry => {
                    const device_name = entry[0];
                    const location_msg = entry[1] as LocationMessage;
                    //const location:LocationMessage = {latitude:location_msg.lat,longitude:location_msg.longitude,level:location_msg.level};
                    location_message[device_name]=location_msg;
                });
            }

            return location_message;
        } //else
    }


    async getDataInternal(device:string,sensor:string,nodeName:string, options:{preload?:boolean,queryStartTimestamp?:number, queryEndTimestamp?:number}): Promise<DataPacket[]|undefined> {
        const data_chunk_timespan = 15000; //ms
        const data_preload_timespan = 300000; //ms
        const data_load_realtime_timespan = 6000; //ms

        if (this.token === null)
            throw new Error("Connection failure");

        let replay_flag:boolean;
        if(options.queryEndTimestamp !== undefined && options.queryStartTimestamp !== undefined){
            replay_flag = true;
        } else {
            replay_flag = false;
        }

        const device_sensor = device+'_'+sensor;
        //if (this.sensorDataQueryMap[device_sensor] !== undefined){
        //    this.sensorDataQueryMap[device_sensor] = {device:device, sensor:sensor, lastDataTimestamp:0};
        //}

        let end_timestamp:number;
        let start_timestamp:number;
        if(options.queryEndTimestamp !== undefined && options.queryStartTimestamp !== undefined){
            //Recall of data
            end_timestamp = options.queryEndTimestamp;
            start_timestamp = options.queryStartTimestamp;
        } else {
            //Real Time
            if(options.preload){
                end_timestamp = Date.now(); //-(this.realtime_query_offet*1000)+5000;
                start_timestamp = end_timestamp-data_preload_timespan;
            } else {
                end_timestamp = Date.now()-(this.realtime_query_offet*1000);
                start_timestamp = end_timestamp-data_load_realtime_timespan;
                if (this.sensorDataQueryMap[device_sensor] !== undefined){
                    if (this.sensorDataQueryMap[device_sensor].lastDataTimestamp < start_timestamp && this.sensorDataQueryMap[device_sensor].lastDataTimestamp+data_preload_timespan > start_timestamp) {
                        start_timestamp = this.sensorDataQueryMap[device_sensor].lastDataTimestamp;
                    }
                }
            }
        }

        let datapacket_messages: DataPacket[] = [];
        let this_start_timestamp = start_timestamp;
        let this_end_timestamp = start_timestamp + data_chunk_timespan;
        if(this_end_timestamp > end_timestamp){
            this_end_timestamp = end_timestamp;
        }

        let promises = [];
        let num_no_data_found = 0;
        //Load data in max 10 second chunks
        let do_loop_flag = true;
        while (do_loop_flag) {

            promises.push(new Promise<void>(async(resolve, j) => {

                const start_time_string = this.convertTimestampToQueryTimestring(this_start_timestamp);
                const end_time_string = this.convertTimestampToQueryTimestring(this_end_timestamp);

                let getdata_string = '/data?start_time='+start_time_string+'&end_time='+end_time_string+'&devices='+device+'&vendors='+sensor;
                //getdata_string = '/data?start_time=20220727120356263&end_time=20220727125738229&devices=OWL_TEST_LOCAL&vendors=MIT-LL-ADAv3';
                //console.log(start_time_string + '  '+end_time_string)
                try{
                    if (this.token === null)
                        throw new Error("Connection failure");

                    let response = await fetch(BD21DataStream.endpoint + getdata_string, {
                        headers: {
                           Authorization: this.token,
                        }

                    });

                    //console.log(response);

                    let data = await response.json();

                    //console.log(data);

                    if(data.data.includes('Error')){
                        //if(this_end_timestamp + data_chunk_timespan > end_timestamp){
                        //console.log('Data replied with: ' +data.data);
                        let statusString = '';
                        if (data.data.includes('No Data found')){
                            //statusString = 'No Data Available'
                            //console.log('No Data Found')
                            statusString = "No Data Found"
                        } else if (data.data.includes('list index out of range')){
                            //statusString = 'No Data in range queried'
                            //console.log('list index out of range')
                            statusString = "No Data Found"
                        }
                        if(statusString === "No Data Found"){
                            //console.log(device_sensor +': No Data msgs between '+this_start_timestamp+' and '+this_end_timestamp)
                            num_no_data_found = num_no_data_found+1;
                        }

                        if(this_end_timestamp + data_chunk_timespan > end_timestamp){
                            console.log(device_sensor +': No Data msgs ('+num_no_data_found+' times) between '+start_timestamp+' and '+end_timestamp)
                            if(!replay_flag){
                                //This keeps reloading like preload if data not found
                                if(this.sensorDataQueryMap[device_sensor]){
                                    if(Date.now()-data_preload_timespan > this.sensorDataQueryMap[device_sensor].lastDataTimestamp){
                                        this.sensorDataQueryMap[device_sensor].lastDataTimestamp = Date.now()-data_preload_timespan; //No need to get anything older than the whole span for live data
                                    }
                                }
                            }

                            //Send datapacket to update device status
                            const datapacket_header = { timestamp: end_timestamp.toString(), device_name: nodeName, vendor: '',statusString: statusString};
                            datapacket_messages.push([datapacket_header, null]);
                            //return datapacket_messages;
                        }
                    } else {
                        //let datapacket_messages: DataPacket[] = [];
                        let header:messages.Core.ExternalSensorMessageHeader|null = null;
                        if (data.data !== undefined && Array.isArray(data.data)){
                            data.data.forEach((msg:string,idx:number) => {
                                if(idx % 2 === 0){
                                    //Even messages are headers
                                    const typed_data = Buffer.from(msg, 'base64');
                                    const transport = new thrift.TFramedTransport(typed_data);
                                    const protocol = new thrift.TBinaryProtocol(transport);
                                    header = new messages.Core.ExternalSensorMessageHeader();
                                    header.read(protocol);

                                } else {
                                    //Odd messages are data of topic defined in header
                                    let parsed_data;
                                    if(header !== null){
                                        const typed_data2 = Buffer.from(msg, 'base64');
                                        const transport2 = new thrift.TFramedTransport(typed_data2);
                                        const protocol2 = new thrift.TBinaryProtocol(transport2);
                                        if (header.topic === messages.SigmaPlusBio.LIFReadingTopic && header.sensor_definition.model === 'IBAC2') {
                                            let parsed_data = new messages.SigmaPlusBio.LIFReading();
                                            parsed_data.read(protocol2);

                                            const timestamp = parseInt(parsed_data.acquisition_end.toString());
                                            let ibac_message = this.parseIBACMessage(timestamp, parsed_data, header);
                                            const datapacket_header = { timestamp: header.time.toString(), device_name: BD21DataStream.remapDeviceName(header.device_name), vendor: 'FLIR', statusString:''};
                                            if (ibac_message !== null){
                                                datapacket_messages.push([datapacket_header, ibac_message]);
                                                if(!replay_flag){
                                                    //Only update unless the timestamp is newer
                                                    if(this.sensorDataQueryMap[device_sensor]){
                                                        if(timestamp > this.sensorDataQueryMap[device_sensor].lastDataTimestamp){
                                                            this.sensorDataQueryMap[device_sensor].lastDataTimestamp = timestamp;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        if (header.topic === messages.SigmaPlusBio.LIFReadingTopic && header.sensor_definition.model === 'TAC7') {
                                            let parsed_data = new messages.SigmaPlusBio.LIFReading();
                                            parsed_data.read(protocol2);

                                            const timestamp = parseInt(parsed_data.acquisition_end.toString());
                                            //console.log(parsed_data)
                                            //TODO Message for TAC7
                                            let tac7_message = this.parseTAC7Message(timestamp, parsed_data, header);
                                            const datapacket_header = { timestamp: header.time.toString(), device_name: BD21DataStream.remapDeviceName(header.device_name), vendor: 'RI',statusString:''};
                                            if (tac7_message !== null){
                                                datapacket_messages.push([datapacket_header, tac7_message]);
                                                if(!replay_flag){
                                                    //Only update unless the timestamp is newer
                                                    if(this.sensorDataQueryMap[device_sensor]){
                                                        if(timestamp > this.sensorDataQueryMap[device_sensor].lastDataTimestamp){
                                                            this.sensorDataQueryMap[device_sensor].lastDataTimestamp = timestamp;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        if (header.topic === messages.SigmaPlusBio.LIFReadingTopic && header.sensor_definition.model === 'TACBIO2') {
                                            let parsed_data = new messages.SigmaPlusBio.LIFReading();
                                            parsed_data.read(protocol2);

                                            const timestamp = parseInt(parsed_data.acquisition_end.toString());
                                            //console.log(parsed_data)
                                            //TODO Message for TACBIO
                                            let tacbio_message = this.parseTACBIOMessage(timestamp, parsed_data, header);
                                            const datapacket_header = { timestamp: header.time.toString(), device_name: BD21DataStream.remapDeviceName(header.device_name), vendor: 'RI',statusString:''};
                                            if (tacbio_message !== null){
                                                datapacket_messages.push([datapacket_header, tacbio_message]);
                                                if(!replay_flag){
                                                    //Only update unless the timestamp is newer
                                                    if(this.sensorDataQueryMap[device_sensor]){
                                                        if(timestamp > this.sensorDataQueryMap[device_sensor].lastDataTimestamp){
                                                            this.sensorDataQueryMap[device_sensor].lastDataTimestamp = timestamp;
                                                        }
                                                    }
                                                }
                                            }
                                        }

                                        if (header.topic === messages.SigmaPlusChem.MeteorologicalReadingTopic) {
                                            let parsed_data = new messages.SigmaPlusChem.MeteorologicalReading();
                                            parsed_data.read(protocol2);

                                            const timestamp = parseInt(parsed_data.time.toString());
                                            let met_message = this.parseMETMessage(timestamp, parsed_data, header);
                                            const datapacket_header = { timestamp: header.time.toString(), device_name: BD21DataStream.remapDeviceName(header.device_name), vendor: 'MET',statusString:''};
                                            if (met_message !== null){
                                                datapacket_messages.push([datapacket_header, met_message]);
                                                if(!replay_flag){
                                                    //Only update unless the timestamp is newer
                                                    if(this.sensorDataQueryMap[device_sensor]){
                                                        if(timestamp > this.sensorDataQueryMap[device_sensor].lastDataTimestamp){
                                                            this.sensorDataQueryMap[device_sensor].lastDataTimestamp = timestamp;
                                                        }
                                                    }
                                                }
                                            }

                                        }
                                        if (header.topic === messages.CBSigmaReport.CBSigmaOutputTopic) {
                                            let parsed_data = new messages.CBSigmaReport.CBSigmaOutput();
                                            parsed_data.read(protocol2);

                                            const timestamp = parseInt(parsed_data.timestamp.toString());
                                            header.device_name = 'PSI';

                                            let cbsigma_message = BD21DataStream.parseCBSigmaMessage(timestamp, parsed_data, header);
                                            const datapacket_header = { timestamp: header.time.toString(), device_name: BD21DataStream.remapDeviceName(header.device_name), vendor: 'PSI CBSIGMA',statusString:''};
                                            if (cbsigma_message !== null){
                                                datapacket_messages.push([datapacket_header, cbsigma_message]);
                                                if(!replay_flag){
                                                    //Only update unless the timestamp is newer
                                                    if(this.sensorDataQueryMap[device_sensor]){
                                                        if(timestamp > this.sensorDataQueryMap[device_sensor].lastDataTimestamp){
                                                            this.sensorDataQueryMap[device_sensor].lastDataTimestamp = timestamp;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        //console.log(parsed_data);

                                        //this.sensorDataQueryMap[device_sensor].lastDataTimestamp = parseInt(header.time.toString());
                                    }
                                }
                            });
                        }

                        //return datapacket_messages;
                    } //else
                }  catch (err) {
                    console.log(err)
                }

                resolve(); //This returns the result

            })); //End of promises

            this_start_timestamp = this_end_timestamp+1;
            this_end_timestamp = this_start_timestamp + data_chunk_timespan;
            if(this_end_timestamp > end_timestamp){
                this_end_timestamp =  end_timestamp;
            }
            if(this_start_timestamp > end_timestamp){
                do_loop_flag = false;
            }

        }


        //N.B. This shows what was received
        //console.log(device_sensor +': Received '+datapacket_messages.length+' Data msgs between '+start_timestamp+' and '+end_timestamp);

        //console.log('read data')
        /*
        //OLD WAY
        return datapacket_messages;
        */

        //ASYNCHRONOUS QUERY USING PROMISE
        const results = [];
        const executing = [];
        let concurrent_limit = 1;

        for (const task of promises) {
            const promise = task; // Execute the task and get a promise

            executing.push(promise);

            if (executing.length >= concurrent_limit) {
                await Promise.race(executing); // Wait for any one of the executing promises to resolve
                //console.log('adding')
                executing.splice(executing.indexOf(promise), 1); // Remove the resolved promise from the executing array
            }

            results.push(await promise); // Store the result of the task
        }
        //Cumulative receive stat
        console.log(device_sensor +': Received '+datapacket_messages.length+' Data msgs between '+start_timestamp+' and '+end_timestamp)
        //console.log('read data')
        const timesorted_datapacket_messages = Object.values(datapacket_messages).sort(
            (lhs, rhs) => Number(lhs[0].timestamp) - Number(rhs[0].timestamp)); //N.B. Need to be sorted in reverse (newest at the end)
        return timesorted_datapacket_messages;

    }




    parseIBACMessage(timestamp: number, data: messages.SigmaPlusBio.LIFReading, header: messages.Core.ExternalSensorMessageHeader): PlottableSensorReading | null {

        //const device = header.sensor_definition.serial_number;  //This is the node
        const device = BD21DataStream.remapDeviceName(header.device_name); //Node Name
        const sensor = header.sensor_definition.make+' '+header.sensor_definition.model; //+' '+header.sensor_definition.serial_number;
        const sensor_type = PlottableSensorTypes.IBAC;
        if(data.number_of_particles.length === 2 && data.number_of_biological_particles.length === 2){

            const latitude = 0.0;
            const longitude = 0.0;

            const particle_count = data.number_of_particles;
            const bio_particle_count = data.number_of_biological_particles;
            let message = new PlottableSensorReading(device, sensor, sensor_type, timestamp,
                latitude, longitude, particle_count, bio_particle_count,);
            return message;
        } else {
            return null;
        }
    }
    parseTAC7Message(timestamp: number, data: messages.SigmaPlusBio.LIFReading, header: messages.Core.ExternalSensorMessageHeader): PlottableSensorReading | null {

        //const device = header.sensor_definition.serial_number;  //This is the node
        const device = BD21DataStream.remapDeviceName(header.device_name); //Node Name
        const sensor = header.sensor_definition.make+' '+header.sensor_definition.model; //+' '+header.sensor_definition.serial_number;
        const sensor_type = PlottableSensorTypes.TAC7;
        if(data.number_of_particles.length === 4 && data.number_of_biological_particles.length === 4){
            const latitude = 0.0;
            const longitude = 0.0;

            const particle_count = data.number_of_particles;
            const bio_particle_count = data.number_of_biological_particles;
            let message = new PlottableSensorReading(device, sensor, sensor_type, timestamp,
                latitude, longitude, particle_count, bio_particle_count);
            return message;
        } else {
            return null;
        }
    }

    parseTACBIOMessage(timestamp: number, data: messages.SigmaPlusBio.LIFReading, header: messages.Core.ExternalSensorMessageHeader): PlottableSensorReading | null {

        //const device = header.sensor_definition.serial_number;  //This is the node
        const device = BD21DataStream.remapDeviceName(header.device_name); //Node Name
        const sensor = header.sensor_definition.make+' '+header.sensor_definition.model; //+' '+header.sensor_definition.serial_number;
        const sensor_type = PlottableSensorTypes.TACBIO;
        if(data.number_of_particles.length  === 4 && data.fluorescent_intensity.length == 2){
            const latitude = 0.0;
            const longitude = 0.0;

            const particle_count = data.number_of_particles;
            const fluorescent_intensity = data.fluorescent_intensity;
            let message = new PlottableSensorReading(device, sensor, sensor_type, timestamp,
                latitude, longitude, particle_count, fluorescent_intensity);
            return message;
        } else {
            return null;
        }
    }

    parseMETMessage(timestamp: number, data: messages.SigmaPlusChem.MeteorologicalReading, header: messages.Core.ExternalSensorMessageHeader): PlottableSensorReading | null {

        //const device = header.sensor_definition.serial_number;  //This is the node
        const device = BD21DataStream.remapDeviceName(header.device_name); //Node Name
        const sensor = header.sensor_definition.make+' '+header.sensor_definition.model; //+' '+header.sensor_definition.serial_number;
        const sensor_type = PlottableSensorTypes.MET;

        //if(data. && data.number_of_biological_particles.length === 4){
        if(data.wind !== undefined){
            const latitude = 0.0;
            const longitude = 0.0;

            const wind_speed = Math.sqrt(data.wind.wind_north*data.wind.wind_north+data.wind.wind_east*data.wind.wind_east);
            let wind_direction = Math.atan2(data.wind.wind_north,data.wind.wind_east) * 180 / Math.PI;
            while (wind_direction < 0)
                wind_direction += 360;
            while (wind_direction > 360)
                wind_direction -= 360;

            const temperature = data.temperature;

            let message = new PlottableSensorReading(device, sensor, sensor_type, timestamp,
                latitude, longitude, null, null ,wind_direction, wind_speed,temperature);
            return message;
        } else {
            return null;
        }
    }
    static parseCBSigmaMessage(timestamp: number, data: messages.CBSigmaReport.CBSigmaOutput, header: messages.Core.ExternalSensorMessageHeader): PlottableSensorReading | null {

        //const device = header.sensor_definition.serial_number;  //This is the node
        const device = BD21DataStream.remapDeviceName(header.device_name);; //BD21DataStream.remapDeviceName(header.device_name); //Node Name
        const sensor = 'PSI CBSIGMA'; //header.sensor_definition.make+' '+header.sensor_definition.model; //+' '+header.sensor_definition.serial_number;
        const sensor_type = PlottableSensorTypes.CBSIGMA;

        if(timestamp < 1e10)
            timestamp *= 1000;

        //HACK
        //console.log('**TIMESTAMP FOR CBSIGMAOUTPUT MSG OFFSET=23MIN')
        //timestamp += 60000*23

        console.log('CBSigma Alg.State: '+data.algorithm_state+' '+data.timestamp);
        //console.log(data)
        //Only return updateable
        if((data.algorithm_state !== messages.CBSigmaReport.AlgorithmState.DID_NOT_PROCESS &&
            data.algorithm_state !== messages.CBSigmaReport.AlgorithmState.DETECTING_NO_UPDATE)){//} && data.detection_significance !== 0){
            let this_cbSigmaOutput = new CBSigmaOutput(
                                        device,
                                        sensor,
                                        timestamp,
                                        data.estimated_release_timestamp,
                                        data.is_detecting,
                                        data.detection_significance,
                                        data.agent_id,
                                        data.algorithm_state,
                                        data.contour_levels,
                                        data.release_location,
                                        )

            let message = new PlottableSensorReading(device, sensor, sensor_type, timestamp,
                null, null, null, null ,null, null,null,null, this_cbSigmaOutput);
            return message;
        } else {
            return null;
        }
    }

    /*
    parseMETMessage(timestamp: number, records: any): METReading | null {
        const device = this.remapDeviceName(records['device'] as string);
        let data = records['data'].split(',');
        switch (data[0]) {
            case '$WIMWV': {
                const windAngle = parseFloat(data[1]);
                const windSpeed = parseFloat(data[3]);

                this.metState[device] = new METReading(device, timestamp, 0.0, 0.0, windAngle, windSpeed, 0.0);
                break;
            }
            case '$WIMDA': {
                const airTemperature = parseFloat(data[5]);
                break;
            }
            case '$GPGGA':
                let latitude = parseFloat(data[2].substring(0, 2)) + parseFloat(data[2].substring(2)) / 60;
                if (data[3] === 'S') {
                    latitude *= -1;
                }
                let longitude = parseFloat(data[4].substring(0, 3)) + parseFloat(data[4].substring(3)) / 60;
                if (data[5] === 'W') {
                    longitude *= -1;
                }

                if (isNaN(latitude) || isNaN(longitude)) {
                    // Handle bogus GPS readings
                    break;
                }

                let windAngle = 0.0, windSpeed = 0.0, airTemperature = 0.0;
                let message = new METReading(device, timestamp, latitude, longitude, windAngle, windSpeed, airTemperature);
                return message;

            default:
                break;
        }

        return null;
    }

    parseAlgorithmResultMessage(timestamp: number, records: any, algorithm: string): AlgorithmResult | null {
        const device = this.remapDeviceName(records['device'] as string);
        let data = records['data'].split(',');
        let alarm = false;
        let confidence = null;
        if(data[0] === 'True'){
            alarm = true;
        }
        if(algorithm === 'PSI Tier 0')
            confidence = parseFloat(data[1]);

        let message = new AlgorithmResult(device, algorithm, timestamp,
            alarm, confidence);

        return message;
    }

    remapDeviceName(device: string){
        let remapped_device_name = device;
        if(device === 'SCRAM038'){
            remapped_device_name = 'IBAC-OWL-038';
        } else if (device === 'SCRAM039'){
            remapped_device_name = 'IBAC-OWL-039';
        }
        return remapped_device_name;
    }
    */
    //THIS ACTUALLY CHANGES THE DEVICE NAME IN THE INVESTIGATION MESSAGE (FOR COSMETIC CHANGE, USE NodeHealth.remapDeviceName())
    static remapDeviceName(device: string){
        let remapped_device_name = device;
        if(String(API_ROOT.Endpoint).includes("lbhrbcrzci")) //THIS IS A HACK FOR BD21 STREAM
            remapped_device_name = device.replace(/\s/g, "");
        if(device === 'Track_23'){
            remapped_device_name = 'GCT Track 23';
        } else if (device === 'Biltmore'){
            remapped_device_name = 'GCT Biltmore';
        } else if (device === 'West_Platform'){
            remapped_device_name = 'GCT West Platform';
        } else if (device === 'East_Platform'){
            remapped_device_name = 'GCT East Platform';
        } else if (device === 'track_104'){
            remapped_device_name = 'GCT Track 104';
        } else if (device === 'Track_113'){
            remapped_device_name = 'GCT Track 113';
        } else if (device === 'west_oyster'){
            remapped_device_name = 'GCT West Oyster';
        } else if (device === 'ewr_arrivals'){
            remapped_device_name = 'EWR Arrivals';
        } else if (device === 'ewr_airtram'){
            remapped_device_name = 'EWR Airtram';
        } else if (device === 'Lexington_Pass'){
            remapped_device_name = 'GCT Lexington Pass';
        } else if (device === 'east_oyster'){
            remapped_device_name = 'GCT East Oyster';
        } else if (device === 'ewr_concourse'){
            remapped_device_name = 'EWR Concourse';
        } else if (device === 'Biltmore'){
            remapped_device_name = 'GCT-Biltmore';
        } else if (device === 'Biltmore'){
            remapped_device_name = 'GCT-Biltmore';
        } else if (device === 'PSI'){
            remapped_device_name = 'NETWORK';
        } else if (device === 'GCT Tier2'){
            remapped_device_name = 'NETWORK';
        } else if (device === 'PSI Tier2'){
            remapped_device_name = 'NETWORK';
        }
        /*
        //DON't USE
        else if (device === 'Krieger-Lincoln-Tunnel'){
            remapped_device_name = 'Krieger Lincoln Tunnel';
        }
        */
        return remapped_device_name;
    }

    convertTimestampToQueryTimestring(timestamp: number):string {
        const date = new Date(timestamp);
        const time_year = date.getUTCFullYear().toFixed(0).padStart(4,'0');
        const time_month = (date.getUTCMonth()+1).toFixed(0).padStart(2,'0');
        const time_day = date.getUTCDate().toFixed(0).padStart(2,'0');
        const time_hour = date.getUTCHours().toFixed(0).padStart(2,'0');
        const time_min = date.getUTCMinutes().toFixed(0).padStart(2,'0');
        const time_sec = date.getUTCSeconds().toFixed(0).padStart(2,'0');

        const query_timestring = time_year+time_month+time_day+time_hour+time_min+time_sec+'000';

        return query_timestring
    }

    setSensorsForDataRequest(sensors:SensorDisplaySelection[]){
        this.sensorDisplaySelection = sensors;
    }

    nodeNameToDeviceMap:{[key:string]:string} = {
        "ewr_concourse": "Washington",
         "Littlton_Hera": "Philadelphia",
         "Abingdon_01": "Abingdon",
         "Littleton_01": "Olympus",
         "Denver_01": "Aphrodite",
         "psi_test": "Apollo",
         "WTC_SE": "Athena",
         "ewr_airtram": "Ares",
         "ewr_arrivals": "Demeter",
         "Seattle_01": "Hermes",
         "Milwaukee_01": "Artemis",
         "Jacksonville_01": "Nike",
         "WTC_NE": "Dionysus",
         "WTC_SC": "Hera",
         "New_York_Poseidon": "Boston",
         "WTC_NW": "Hypnos",
         "Abingdon_Nemesis": "Nemesis",
         "Breezetunnel_10": "Tabletop",
         "Breezetunnel_11": "Tabletop",
         "Breezetunnel_12": "Tabletop",
         "Breezetunnel_13": "Nemesis",
         "Breezetunnel_14": "Nemesis",
         "Breezetunnel_15": "Nemesis",
         "Breezetunnel_16": "Nemesis",
         "Breezetunnel_17": "Nemesis",
         "Breezetunnel_18": "Nemesis",
         "Breezetunnel_19": "Nemesis",
         "Breezetunnel_20": "Nemesis",
         "Breezetunnel_21": "Nemesis",
         "Breezetunnel_22": "breezetunnel",
         "Breezetunnel_23": "breezetunnel",
         "Breezetunnel_24": "Nemesis",
         "Breezetunnel_25": "Nemesis",
         "Breezetunnel_26": "Nemesis",
         "Breezetunnel_27": "Nemesis",
         "Breezetunnel_28": "Nemesis",
         "Breezetunnel_29": "Nemesis",
         "WTC_SW": "Poseidon",
         "Breezetunnel_05": "breezetunnel",
         "Breezetunnel_06": "breezetunnel",
         "Breezetunnel_04": "breezetunnel",
         "Breezetunnel_09": "breezetunnel",
         "SIGMA_NY_NE": "SCRAM006",
         "SIGMA_NY_NW": "SCRAM028",
         "SIGMA_NY_SW": "SCRAM017",
         "SIGMA_NY_SE": "SCRAM036",
         "Lexington_Pass": "OWL0016",
         "Biltmore": "OWL0022",
         "Mobile_38": "SCRAM038",
         "Mobile_39": "SCRAM039",
         "Track_23": "OWL0020",
         "west_oyster": "OWL0021",
         "east_oyster": "OWL0019",
         "West_Platform": "OWL0014",
         "East_Platform": "OWL0015",
         "Track_113": "OWL0017",
         "track_104": "OWL0018",
         "Backpack001": "Backpack-001",
         "Backpack002": "Backpack-002",
         //"Krieger Lincoln Tunnel":"Krieger-Lincoln-Tunnel", //DON't USE
         "GCT Tier2": "PSI",
         "PSI":"PSI"}

}
